import { render } from "./IconSend.vue?vue&type=template&id=f3053564"
import script from "./IconSend.vue?vue&type=script&lang=ts"
export * from "./IconSend.vue?vue&type=script&lang=ts"
script.render = render

export default script